import { ajax } from '../../../services/helper'
class ApiService {

    getAttendanceData = (cycle_id,workLocationType,workLocationId,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/attendances/list?cycle_id="+cycle_id+"&location_type="+workLocationType+"&location_id="+workLocationId+"&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

       getLatestAttendanceCycle = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/attendanceCycles/list?status=NEW"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getAttendanceDataSimplifiedFormnat = (cycle_id,workLocationType,workLocationId,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/attendances/export?cycle_id="+cycle_id+"&location_type="+workLocationType+"&location_id="+workLocationId+"&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
    
   

   

   
    getAttendanceById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brands/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getAttendanceGroupsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brandGroups/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    


    addAttendance = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/attendances/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editAttendance = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/attendances/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



  getTeamAttendanceByKitchenId = (id,attendancesDateCheck,attendance_date) => {
        if(attendancesDateCheck){
            return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/"+id+"/listTeam?attendance_date="+attendance_date
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })

        }else{
            return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/"+id+"/listTeam"
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }
    }

    

    getTeamAttendanceByWorkLocationId = (workLocationType,workLocationId,departmentId,attendancesDateCheck,attendance_date) => {
        
        if(attendancesDateCheck){
            return new Promise((resolve, reject) => {
                const url = "/v1/employees/getAttendanceDetails?location_type="+workLocationType+"&location_id="+workLocationId+"&department_id="+departmentId+"&attendance_date="+attendance_date
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })

        }else{
            return new Promise((resolve, reject) => {
                const url = "/v1/employees/getAttendanceDetails?location_type="+workLocationType+"&location_id="+workLocationId+"&department_id="+departmentId
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        }
    }

     getAttendanceEditInfo = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/attendances/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Attendance/services/apiservices.js